import environment from "./base";

const API_URL = "https://uf.rel.noclef.com";
const ADS_BOX_API_URL = "https://adsbox.insigit.com";
const ADS_BOX_API_KEY = "4UpvcPk2xyeFsVc5";

export default environment(API_URL, ADS_BOX_API_URL, ADS_BOX_API_KEY);
